import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';

import { getAuthHeader } from '@/entities/auth';
import { getBillingServiceBaseUrl } from '@/shared/lib/config/env';

let client: AxiosInstance | null = null;
let clientBase: string | null = null;

export const getBillingHttpClient = (): AxiosInstance => {
  const baseUrl = getBillingServiceBaseUrl();
  if (!baseUrl) {
    throw new Error('Billing service URL is not configured (VITE_BILLING_URL or VITE_BILING_URL)');
  }

  if (client && clientBase === baseUrl) {
    return client;
  }

  clientBase = baseUrl;
  client = axios.create({
    baseURL: `${baseUrl}/api/v1`,
  });

  client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const auth = getAuthHeader();
    if (auth?.Authorization) {
      config.headers.set('Authorization', auth.Authorization);
    }
    return config;
  });

  return client;
};

export const isBillingHttpConfigured = (): boolean => Boolean(getBillingServiceBaseUrl());
